import React ,{ useState, useEffect } from 'react';
import { Link } from 'react-router-dom';


const Header = () => {

  const [categories, setCategories] = useState({});
  const [error, setError] = useState(null);

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    // APIのエンドポイントを指定
    fetch('/req_api/categories.php') 
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        // 取得したJSONデータをstateにセット
        setCategories(data);
      })
      .catch(error => {
        setError(error);
        console.error('Error fetching categories:', error);
      });
  }, []);
  

  if (error) {
    return <div>エラーが発生しました: {error.message}</div>;
  }



  return (
    <div>
      <header>
          <div className="logo">
            <h1><Link to="/"><img src="/assets/img/logo.png" alt="ロドストURL短縮サイト FFXIV.LINK " /></Link></h1>
            <p className="headtxt">ロドスト(The Lodestone) 短縮URL作成サイト &amp; FFXIVリンク集</p>
          </div>
          <div id="spMenu" className="spOnly">
            <div className={`menu-trigger ${isOpen ? 'active' : ''}`} onClick={toggleMenu} aria-expanded={isOpen}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>

      </header>
      
      <nav id="glb_nav" className={`${isOpen ? 'active' : ''}`}>
        <ul>
          <li><Link to="/" onClick={closeMenu}>ロドストURL短縮</Link></li>
          {Object.keys(categories).map(key => (
            // keyはcat01, cat02など。
            // categories[key]は公式, データベースなど。
            <li key={key}>
              <Link to={`/${key}`} onClick={closeMenu}>
                {categories[key]}
              </Link>
            </li>
          ))}
          <li><Link to="/link" onClick={closeMenu}>サイト登録</Link></li>
        </ul>
      </nav>
  </div>
  );
};

export default Header;